module.exports = __webpack_public_path__ + "img/status0_icon4.853a04b8.png";